var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecretarial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79993 13.2V6C4.79993 5.66577 4.9166 5.38222 5.14993 5.14933C5.38326 4.91644 5.6666 4.8 5.99993 4.8H13.1999C13.5299 4.8 13.8124 4.9175 14.0474 5.1525C14.2824 5.3875 14.3999 5.67 14.3999 6V11.2L11.1999 14.4H5.99993C5.66993 14.4 5.38743 14.2825 5.15243 14.0475C4.91743 13.8125 4.79993 13.53 4.79993 13.2ZM1.63326 4.28333C1.57771 3.96111 1.64715 3.66111 1.8416 3.38333C2.03604 3.10555 2.29438 2.93889 2.6166 2.88333L9.69993 1.61666C10.0222 1.56111 10.3194 1.63055 10.5916 1.825C10.8638 2.01944 11.0277 2.27777 11.0833 2.6L11.2666 3.6H10.0499L9.89993 2.8L2.8166 4.06666L3.59993 8.45V12.25C3.42215 12.1722 3.26938 12.0551 3.1416 11.8987C3.01382 11.7422 2.93326 11.5649 2.89993 11.3667L1.63326 4.28333ZM5.99993 6V13.2H10.3999V10.4H13.1999V6H5.99993Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecretarial);
export default __webpack_public_path__ + "static/media/Secretarial.8ff93502d3dc2c1f53f60c0e6c2aee5b.svg";
export { ForwardRef as ReactComponent };